import { Box, Text, Flex, Button, useBreakpointValue,Image } from '@chakra-ui/react'
import { AnimatePresence, motion } from 'framer-motion'
import { useStore } from '@store'
import { observer } from 'mobx-react-lite'
import useTranslation from 'next-translate/useTranslation'
import { Link } from '@ui'
import { Plus } from '@icon'
import { sideMenuAnim } from '@lib/motion'

interface IExhibitionAndEventDetailHeroCard {
  title: string
  date: string
  displayBuyTicketButtonGroup?: boolean
  displayFooterButtonGroup?: boolean
}

const WebPerformanceDetailHeroCard = observer(
  ({
     title,
     date,
     displayBuyTicketButtonGroup = false,
     displayFooterButtonGroup = false,
   }: IExhibitionAndEventDetailHeroCard) => {
    const {
      ui: { displayBannerSlider },
    } = useStore()
    const { t } = useTranslation('exhibition-and-event')
    const isDesktop = useBreakpointValue({ base: false, lg: true })

    const handleBuyATicket = () => alert('Buy a ticket action')

    return (
      <Box
        position="absolute"
        bottom={{ base: '-70px', lg: '-45px' }}
        left={0}
        width="full"
        height="auto"
        maxWidth={{ base: 'calc(100vw - 30px)', lg: '60%' }}
        zIndex="1"
      >
        <AnimatePresence exitBeforeEnter>
          {displayBannerSlider && (
            <Box
              as={motion.div}
              variants={sideMenuAnim.sliderMotion}
              initial="hidden"
              animate={{ ...sideMenuAnim.sliderMotion.visible, y: 0 }}
              exit="hidden"
              bgColor="red.primary"
              py={{ base: 9, lg: '60px' }}
              px={{ base: 10, lg: 14 }}
            >
              <Text
                as="h6"
                color="black.primary"
                mb={{ base: '10px', lg: 5 }}
                noOfLines={1}
                fontFamily="heading"
              >
                {date}
              </Text>
              <Text
                as="h3"
                color="white.primary"
                noOfLines={3}
                mb={5}
                fontSize={{ base: '30px', lg: '32px' }}
                fontFamily="heading"
              >
                {title}
              </Text>
              {displayBuyTicketButtonGroup && (
                <Flex
                  flexDirection={{ base: 'column', lg: 'row' }}
                  alignItems="flex-start"
                >
                  <Button
                    leftIcon={<Plus width="10px" height="10px" />}
                    variant="unstyled"
                    color="white.primary"
                    onClick={handleBuyATicket}
                  >
                    <Text as="span" fontWeight="light">
                      {t('eventAndExhibitionDetail.buyATicket')}
                    </Text>
                  </Button>
                  <Button
                    as={Link}
                    target="_blank"
                    href="https://www.sakipsabancimuzesi.org/bilet/rezervasyon-formu/"
                    display="flex"
                    leftIcon={<Plus width="10px" height="10px" />}
                    variant="unstyled"
                    color="white.primary"
                    ml={{ base: 0, lg: 3 }}
                  >
                    <Text as="span" fontWeight="light">
                      {t('eventAndExhibitionDetail.makeAReservation')}
                    </Text>
                  </Button>
                </Flex>
              )}
            </Box>
          )}
        </AnimatePresence>
        <Flex
          bgColor="black.primary2"
          height={{ base: '70px', lg: '85px' }}
          flexDirection="row"
          alignItems="center"
          color="white.primary"
          px={{ base: 10, lg: 16 }}
          gap={{ base: 2, lg: 4 }}
          opacity={displayFooterButtonGroup ? 1 : 0}
          transform={
            displayBannerSlider
              ? 'translateY(0px)'
              : isDesktop
                ? 'translateY(-85px)'
                : 'translateY(-70px)'
          }
          transition="all 0.5s ease-in-out"
          justifyContent="start"
        >
          {/* Sol taraf: copyright */}
          <Text fontSize={{ base: 'xs', lg: '20px' }} fontWeight="light" fontFamily="heading">
            Desteğiyle/Sponsored by |
          </Text>

          {/* Sağ taraf: kişi/firma */}
          <Image src="https://drupal.sakipsabancimuzesi.org/sites/default/files/2026-03/b699da514e3b8066b2475714773714872cf5ac80.png" alt="logo" width={{ base: '100px', lg: '200px' }} height="auto" />

        </Flex>
      </Box>
    )
  }
)

export default WebPerformanceDetailHeroCard
